const initialState = {
    club: {},
    clubs: []
};
export default function clubReducer(state = initialState, action = {type: ''}) {
    switch (action.type) {
        case 'ADD_CLUB': {
            if (!action.accounts) {
                return {
                    ...state
                };
            }
            return {
                ...state,
                clubs: [...state.clubs, action.data]
            };
        }
        case 'SET_CLUB': {
            return {
                ...state,
                club: action.data
            };
        }
        case 'SET_CLUBS': {
            return {
                ...state,
                clubs: [action.data]
            };
        }
    }
    return state;
}
